import PropTypes from 'prop-types'
import {useEffect} from 'react'

import {Grid} from '@material-ui/core'
import {FormScanApi} from '../../../containers'


const NewScanApi = (props) => {
  useEffect(() => {
    props.setTitle(props.title)
  }, [])

  return (
    <section className="content">
      <Grid>
        <FormScanApi {...props} title="Criar Scan de API"/>
      </Grid>
    </section>
  )
}

NewScanApi.propTypes = {
  params: PropTypes.object,
  setTitle: PropTypes.func,
  title: PropTypes.string,
}

export default NewScanApi;
